import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const UserInfo = () => {
    const [userInfo, setUserInfo] = useState({
        name: '',
        email: '',
        company: ''
    });
    const navigate = useNavigate();
    const { type } = useParams();

    const handleInputChange = (e) => {
        setUserInfo({
            ...userInfo,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (userInfo.name && userInfo.email && userInfo.company) {
            navigate(`/calculate/${type}`, { state: userInfo });
        } else {
            alert('Please fill in all fields.');
        }
    };

    return (
        <div className="h-screen flex items-center justify-center bg-light-brown text-dark-gray">
            <div className="max-w-md mx-auto p-8">
                <h2 className="text-4xl font-bold text-center mb-4">User Information</h2>
                <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Name<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={userInfo.name}
                            onChange={handleInputChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder="Name"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Email<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={userInfo.email}
                            onChange={handleInputChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder="Email"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Company Name<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="company"
                            value={userInfo.company}
                            onChange={handleInputChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder="Company Name"
                            required
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            type="submit"
                        >
                            Continue
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserInfo;